/* Morgan & Reid — PDP bundle builder (Phase 3), non-destructive mount.
 * v5: auto-expand after variant picker interaction once catalog is ready.
 * v6: availability-aware summary — an unavailable slot shows "<room>: <colour> <size>
 *     unavailable — change size or colour" instead of "Bundle ready" (the native button
 *     is theme-disabled when the PDP variant is sold out, so the old summary lied).
 * v7 (2026-09-10): CONFIG-DRIVEN GATE — the builder mounts only when THIS product is in one of
 *     the qualifying collections returned by /api/bundle-discount-config (and not in an excluded
 *     one). Any template can render the snippet; the collections decide. Config unreachable or
 *     product not qualifying -> nothing mounts and the native Add to Cart is untouched (fail closed).
 * v8 (2026-09-12): RANGES ARE SEPARATE — the catalogue is the anchor's OWN qualifying collection
 *     only (tiers count within one range in the Function too), and the copy names the range
 *     ("Build your Snuggle Fleece bundle & save").
 * v9 (2026-09-25): NOUN FOLLOWS THE PRODUCT TYPE — tier labels and the summary said "comforter(s)"
 *     everywhere, including on Coverlets (the Coverlets collection is now a qualifying range). The
 *     noun is now read from the PDP's own product.type (data-product-type): "Coverlets" -> coverlet/
 *     coverlets, "Comforters" -> comforter/comforters, anything else -> the neutral set/sets.
 */
(function () {
  "use strict";

  var DISCOUNT = { 1: 0, 2: 0.10, 3: 0.15 };

  var root = document.querySelector(".mr-bundle");
  if (!root) return;

  var API_BASE = (root.getAttribute("data-api-base") || "").replace(/\/$/, "");
  var SHOP = root.getAttribute("data-shop") || (window.Shopify && window.Shopify.shop) || "";
  var PRODUCT_TITLE = root.getAttribute("data-product-title") || "";
  var PRODUCT_ID = root.getAttribute("data-product-id") || "";
  var PRODUCT_TYPE = root.getAttribute("data-product-type") || "";
  var CONTACT = root.getAttribute("data-contact") || "hello@morganandreid.com";
  var ROUTE_ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";

  var $ = function (sel) { return root.querySelector(sel); };
  var fmt = function (cents) { return "$" + (cents / 100).toFixed(2); };
  var toCents = function (price) {
    if (typeof price === "number") return Math.round(price);
    return Math.round(parseFloat(price) * 100);
  };
  var imgUrl = function (src, w) {
    if (!src) return ""; var clean = src.split("?")[0]; return clean + "?width=" + w;
  };
  var numId = function (id) { return String(id).replace(/\D/g, ""); };
  var stripOrdinal = function (d) { return String(d || "").replace(/(\d+)(st|nd|rd|th)\b/gi, "$1"); };

  var ROOMS = ["Main bedroom", "Guest room", "Kids' room"];
  var BED = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M3 18v-5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v5"/><path d="M3 18v2M21 18v2M3 13h18"/><path d="M7 11V9.5a1 1 0 0 1 1-1h3V11"/></svg>';

  // v9: the noun for this product's type, singular/plural. Falls back to "set/sets" for a product
  // type this widget hasn't been told about, so new ranges never show a wrong word.
  var NOUN = (function (type) {
    var t = String(type || "").trim().toLowerCase();
    if (t.indexOf("coverlet") !== -1) return { s: "coverlet", p: "coverlets" };
    if (t.indexOf("comforter") !== -1) return { s: "comforter", p: "comforters" };
    return { s: "set", p: "sets" };
  })(PRODUCT_TYPE);
  var cap = function (s) { return s.charAt(0).toUpperCase() + s.slice(1); };

  // ---- State ---------------------------------------------------------------
  var qty = 1;
  var slot1 = null;
  var groups = [];
  var preorderMap = {};
  var catalogReady = false;
  var productQualifies = false; // v7: set by loadCatalog() when PRODUCT_ID is in a qualifying collection
  var rangeName = "";           // v8: display name of the anchor's range ("Gingham", "Snuggle Fleece")
  var targetForm = null;
  var adding = false;
  var extras = { 2: { gi: 0, pi: 0, si: 0, open: false, sizeTouched: false }, 3: { gi: 0, pi: 0, si: 0, open: false, sizeTouched: false } };

  // ---- Auto-expand ---------------------------------------------------------
  // pickerUsed: set true the first time variant:change fires after page load.
  // We use this to know the customer has interacted with the picker.
  // When catalog finishes loading, if pickerUsed is already true we expand immediately.
  // If catalog loads first, we wait for picker interaction.
  // hasAutoExpanded prevents firing more than once.
  var pickerUsed = false;
  var hasAutoExpanded = false;

  function doExpand() {
    if (hasAutoExpanded) return;
    var expand = $("[data-expand]");
    var moreBtn = $("[data-more]");
    if (!expand || !moreBtn || !expand.hidden) return;
    hasAutoExpanded = true;
    setTimeout(function () {
      expand.hidden = false;
      moreBtn.setAttribute("aria-expanded", "true");
      expand.classList.remove("anim");
      void expand.offsetWidth;
      expand.classList.add("anim");
      if (qty < 2) select(2); else render();
      var top = root.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: top, behavior: "smooth" });
    }, 300);
  }

  function onPickerUsed() {
    if (hasAutoExpanded) return;
    pickerUsed = true;
    // If catalog is already ready, expand now. Otherwise loadCatalog's .then() will call doExpand.
    if (catalogReady) doExpand();
  }

  // ---- Native buy-button ---------------------------------------------------
  var submitBtn = null, priceHasCode = false, btnObserver = null;
  var stickyBtn = null, stickyPriceEl = null, stickyBtnObserver = null, stickyPriceDirty = false;
  var stickyTitleEl = null, stickySubEl = null, stickyCardDirty = false;

  // ---- Pre-order helpers ---------------------------------------------------
  function preorderFor(variantId) { return preorderMap[numId(variantId)] || null; }
  function slot1PreProperty() {
    var el = document.getElementById("cstm-property-preorder");
    if (el && el.getAttribute("name") === "properties[Pre]" && el.value) return el.value;
    var po = slot1 && preorderFor(slot1.variantId);
    return po ? po.note : null;
  }

  // ---- Slot 1 --------------------------------------------------------------
  function slot1FromVariant(v) {
    return {
      variantId: v.id,
      priceCents: toCents(v.price),
      label: v.title || "",
      image: (v.featured_image && v.featured_image.src) || (slot1 && slot1.image) || root.getAttribute("data-product-image") || "",
      available: v.available !== false,
    };
  }
  function readSlot1() {
    var el = document.querySelector('variant-picker script[type="application/json"][data-selected-variant]');
    if (!el) return false;
    var v; try { v = JSON.parse(el.textContent); } catch (e) { return false; }
    if (!v || !v.id) return false;
    slot1 = slot1FromVariant(v);
    return true;
  }

  // ---- Catalog -------------------------------------------------------------
  function fetchCollectionProducts(handle) {
    var out = [];
    function page(p) {
      return fetch(ROUTE_ROOT + "collections/" + handle + "/products.json?limit=250&page=" + p)
        .then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (data) {
          var products = (data && data.products) || [];
          out = out.concat(products);
          if (products.length === 250 && p < 20) return page(p + 1);
        });
    }
    return page(1).then(function () { return out; }).catch(function () { return out; });
  }
  function sizeOptionIndex(product) {
    var opts = product.options || [];
    for (var i = 0; i < opts.length; i++) {
      var name = (typeof opts[i] === "string" ? opts[i] : opts[i].name) || "";
      if (/size/i.test(name)) return i + 1;
    }
    return opts.length === 1 ? 1 : 0;
  }
  var FAMILY_ORDER = [
    { key: "snuggle", title: "Snuggle Fleece" },
    { key: "checkered", title: "Checkered" },
    { key: "velvet", title: "Velvet" },
    { key: "rabbit", title: "Rabbit Faux Fur" },
  ];
  function familyOf(product, defaultFam) {
    var tags = Array.isArray(product.tags) ? product.tags : String(product.tags || "").split(",");
    var fam = defaultFam;
    tags.forEach(function (t) {
      t = String(t).trim();
      if (t === "comforter-type-checkered") fam = "checkered";
      else if (t === "comforter-type-velvet") fam = "velvet";
      else if (t === "comforter-type-rabbit") fam = "rabbit";
    });
    return fam;
  }
  function removeAll(s, sub) { return s.split(sub).join(""); }
  function colourName(title) {
    var n = title || "";
    n = removeAll(n, " Snuggle Fleece Comforter Set");
    n = removeAll(n, " Checkered Snuggle Fleece Comforter Set");
    n = removeAll(n, " Velvet Crushed Snuggle Fleece Comforter Set");
    n = removeAll(n, " Velvet Stripe Snuggle Fleece Comforter Set");
    n = removeAll(n, " Heavy Weight Snuggle Fleece Comforter Set");
    n = removeAll(n, " Rabbit Fur Comforter Set");
    n = removeAll(n, "Morgan and Reid ");
    return n;
  }
  function normalizeProduct(product) {
    var oi = sizeOptionIndex(product);
    var prodImage = (product.image && product.image.src) ||
      (product.images && product.images[0] && (product.images[0].src || product.images[0])) || "";
    var sizes = (product.variants || []).map(function (v) {
      var label = oi ? v["option" + oi] : v.title;
      return { variantId: v.id, label: label || v.title, priceCents: toCents(v.price), available: v.available !== false, image: (v.featured_image && v.featured_image.src) || prodImage };
    });
    return { id: product.id, handle: product.handle, title: product.title, colour: colourName(product.title), image: prodImage, sizes: sizes };
  }
  function loadCatalog() {
    if (!API_BASE || !SHOP) return Promise.resolve();
    return fetch(API_BASE + "/api/bundle-discount-config?shop=" + encodeURIComponent(SHOP))
      .then(function (r) { return r.json(); })
      .then(function (cfg) {
        preorderMap = (cfg && cfg.preorder) || {};
        var qualifying = (cfg && cfg.qualifying) || [];
        var exclude = (cfg && cfg.exclude) || [];
        if (!qualifying.length) return;
        return Promise.all(exclude.map(function (c) { return fetchCollectionProducts(c.handle); }))
          .then(function (exLists) {
            var excludeHandles = new Set();
            exLists.forEach(function (list) { list.forEach(function (p) { if (p.handle) excludeHandles.add(p.handle); }); });
            return Promise.all(qualifying.map(function (c) { return fetchCollectionProducts(c.handle); }))
              .then(function (lists) {
                var seen = new Set(); var byFamily = {};
                var here = numId(PRODUCT_ID);
                // v8: the anchor's own range = the FIRST qualifying collection that contains this product.
                var anchorIdx = -1;
                lists.forEach(function (list, idx) { if (anchorIdx >= 0) return; (list || []).forEach(function (p) { if (anchorIdx < 0 && here && numId(p.id) === here && p.handle && !excludeHandles.has(p.handle)) anchorIdx = idx; }); });
                productQualifies = anchorIdx >= 0;
                if (!productQualifies) return;
                rangeName = String(qualifying[anchorIdx].title || "").replace(/\s*comforters?\s+range\s*$/i, "").trim();
                qualifying.forEach(function (c, idx) {
                  if (idx !== anchorIdx) return; // catalogue = this range only
                  var defaultFam = (/rabbit/i.test(c.handle) || /rabbit/i.test(c.title)) ? "rabbit" : "snuggle";
                  (lists[idx] || [])
                    .filter(function (p) { return p.handle && !excludeHandles.has(p.handle) && !seen.has(p.id) && (p.variants || []).length > 0; })
                    .forEach(function (p) { seen.add(p.id); var fam = familyOf(p, defaultFam); (byFamily[fam] = byFamily[fam] || []).push(normalizeProduct(p)); });
                });
                FAMILY_ORDER.forEach(function (f) { if (byFamily[f.key] && byFamily[f.key].length) groups.push({ title: f.title, key: f.key, products: byFamily[f.key] }); });
                catalogReady = groups.length > 0;
              });
          });
      })
      .catch(function () { });
  }

  // ---- Extra-slot resolution -----------------------------------------------
  function extraVariant(i) {
    var st = extras[i]; var g = groups[st.gi]; if (!g) return null;
    var p = g.products[st.pi]; if (!p) return null;
    var s = p.sizes[st.si] || p.sizes[0]; if (!s) return null;
    var po = preorderFor(s.variantId);
    return { product: p, size: s, variantId: s.variantId, priceCents: s.priceCents, available: s.available, image: s.image, name: p.colour || p.title, sizeLabel: s.label, preorder: !!po, preorderDate: po ? po.date : "" };
  }
  function firstAvailableSize(gi, pi) {
    var p = groups[gi] && groups[gi].products[pi]; if (!p) return 0;
    for (var i = 0; i < p.sizes.length; i++) if (p.sizes[i].available) return i;
    return 0;
  }
  function sizeIndexFor(gi, pi, preferredLabel) {
    var p = groups[gi] && groups[gi].products[pi]; if (!p) return 0;
    var want = String(preferredLabel || "").trim().toLowerCase();
    if (want) for (var i = 0; i < p.sizes.length; i++) if (p.sizes[i].available && String(p.sizes[i].label || "").trim().toLowerCase() === want) return i;
    return firstAvailableSize(gi, pi);
  }
  function syncExtraSizes() {
    if (!slot1) return;
    [2, 3].forEach(function (i) { if (!extras[i].sizeTouched) extras[i].si = sizeIndexFor(extras[i].gi, extras[i].pi, slot1.label); });
  }

  // ---- Pricing -------------------------------------------------------------
  function slotList(q) {
    var list = [];
    if (slot1) list.push({ priceCents: slot1.priceCents, preorder: !!preorderFor(slot1.variantId) });
    for (var i = 2; i <= q; i++) { var ev = extraVariant(i); if (ev) list.push({ priceCents: ev.priceCents, preorder: ev.preorder }); }
    return list;
  }
  function calc(q) {
    var pct = DISCOUNT[q] || 0; var subtotal = 0, saved = 0;
    slotList(q).forEach(function (s) { subtotal += s.priceCents; saved += Math.round(s.priceCents * pct); });
    return { subtotal: subtotal, save: saved, total: subtotal - saved };
  }
  // Slots whose selected variant can't be bought right now, as "<room>: <colour> <size>"
  // strings. Slot 1 is the PDP's own picker (the theme greys the native button for it);
  // extras can land here when a colour has no available size at all.
  function unavailableSlots(q) {
    var out = [];
    if (slot1 && slot1.available === false) out.push(ROOMS[0] + ": " + colourName(PRODUCT_TITLE) + " " + slot1.label);
    for (var i = 2; i <= q; i++) { var ev = extraVariant(i); if (ev && !ev.available) out.push((ROOMS[i - 1] || (cap(NOUN.s) + " " + i)) + ": " + ev.name + " " + ev.sizeLabel); }
    return out;
  }

  // ---- Native buy-button ---------------------------------------------------
  function bundleAllPre() { var list = slotList(qty); return list.length > 0 && list.every(function (s) { return s.preorder; }); }
  function applyBundleButton() {
    if (!submitBtn || !slot1 || qty < 2) return;
    var labelEl = submitBtn.querySelector(".btn_text_fill"); var priceEl = submitBtn.querySelector("product-buy-price");
    var wantLabel = bundleAllPre() ? "Pre-order" : "Add bundle";
    var wantPrice = "$" + (calc(qty).total / 100).toFixed(2) + (priceHasCode ? " AUD" : "");
    if (labelEl && labelEl.textContent !== wantLabel) labelEl.textContent = wantLabel;
    if (priceEl && priceEl.textContent !== wantPrice) priceEl.textContent = wantPrice;
    if (stickyBtn) { var sLabel = stickyBtn.querySelector(".btn_text_fill"); if (sLabel && sLabel.textContent !== wantLabel) sLabel.textContent = wantLabel; }
    if (stickyPriceEl && stickyPriceEl.textContent !== wantPrice) stickyPriceEl.textContent = wantPrice;
    if (stickyTitleEl) { var sTitle = qty + " " + NOUN.p; if (stickyTitleEl.textContent !== sTitle) stickyTitleEl.textContent = sTitle; }
    if (stickySubEl) { var cols = [colourName(PRODUCT_TITLE)]; for (var ci = 2; ci <= qty; ci++) { var cev = extraVariant(ci); if (cev) cols.push(cev.name); } var sSub = cols.join(", "); if (stickySubEl.textContent !== sSub) stickySubEl.textContent = sSub; }
    stickyPriceDirty = true;
    stickyCardDirty = true;
  }
  function restoreNativeButton() {
    if (!submitBtn || !slot1 || !slot1.available) return;
    var labelEl = submitBtn.querySelector(".btn_text_fill"); var priceEl = submitBtn.querySelector("product-buy-price");
    var wantLabel = preorderFor(slot1.variantId) ? "Pre-order" : "Add to cart";
    var wantPrice = "$" + (slot1.priceCents / 100).toFixed(2) + (priceHasCode ? " AUD" : "");
    if (labelEl && labelEl.textContent !== wantLabel) labelEl.textContent = wantLabel;
    if (priceEl && priceEl.textContent !== wantPrice) priceEl.textContent = wantPrice;
    if (stickyBtn) { var sLabel = stickyBtn.querySelector(".btn_text_fill"); if (sLabel && sLabel.textContent !== wantLabel) sLabel.textContent = wantLabel; }
    if (stickyPriceDirty && stickyPriceEl && stickyPriceEl.textContent !== wantPrice) { stickyPriceEl.textContent = wantPrice; stickyPriceDirty = false; }
    if (stickyCardDirty) { if (stickyTitleEl && stickyTitleEl.textContent !== PRODUCT_TITLE) stickyTitleEl.textContent = PRODUCT_TITLE; if (stickySubEl && slot1 && stickySubEl.textContent !== slot1.label) stickySubEl.textContent = slot1.label; stickyCardDirty = false; }
  }
  function syncButton() { if (qty >= 2) applyBundleButton(); else restoreNativeButton(); }

  // ---- Render --------------------------------------------------------------
  function buildTiers() {
    var el = $("[data-tiers]"); el.innerHTML = "";
    var TIERS = [
      { qty: 1, name: "1 " + NOUN.s, desc: "Just your own bed.", badge: null, rooms: null },
      { qty: 2, name: "2 " + NOUN.p, desc: null, badge: "Most popular", rooms: ["Main bedroom", "Guest room"] },
      { qty: 3, name: "3 " + NOUN.p, desc: null, badge: "Best value", rooms: ["Main", "Guest", "Kids' room"] },
    ];
    TIERS.forEach(function (t) {
      var label = document.createElement("label");
      label.className = "mr-tier"; label.setAttribute("data-qty", t.qty);
      label.innerHTML =
        (t.badge ? '<span class="mr-badge">' + t.badge + "</span>" : "") +
        '<input class="mr-tier__input" type="radio" name="mr-qty" value="' + t.qty + '">' +
        '<span class="mr-tier__dot" aria-hidden="true"></span>' +
        '<div class="mr-tier__row"><div>' +
        '<p class="mr-tier__name">' + t.name + "</p>" +
        (t.desc ? '<p class="mr-tier__desc">' + t.desc + "</p>" : "") +
        (t.rooms ? '<div class="mr-rooms">' + t.rooms.map(function (r) { return '<span class="mr-room">' + BED + r + "</span>"; }).join("") + "</div>" : "") +
        (t.qty > 1 ? '<span class="mr-save">Save ' + Math.round(DISCOUNT[t.qty] * 100) + '%</span><span class="mr-saveamt" data-sv="' + t.qty + '"></span>' : "") +
        '</div><div class="mr-price"><p class="mr-price__now" data-pn="' + t.qty + '"></p></div></div>';
      label.querySelector("input").addEventListener("change", function () { select(t.qty); });
      el.appendChild(label);
    });
  }
  function buildRows() {
    var rowsEl = $("[data-rows]"); rowsEl.innerHTML = "";
    for (var i = 2; i <= qty; i++) {
      var st = extras[i]; var ev = extraVariant(i); if (!ev) continue;
      var g = groups[st.gi];
      var poChip = ev.preorder ? '<span class="mr-po"><span class="mr-po__tag">Pre-order</span><span class="mr-po__meta">ships ' + ev.preorderDate + "</span></span>" : "";
      var row = document.createElement("div"); row.className = "mr-item";
      row.innerHTML =
        '<div class="mr-item__summary">' +
        '<span class="mr-thumb" style="background-image:url(' + imgUrl(ev.image, 80) + ')"></span>' +
        '<span class="mr-item__meta">' +
        '<span class="mr-item__label"><span class="mr-bed">' + BED + "</span>" + (ROOMS[i - 1] || (cap(NOUN.s) + " " + i)) + "</span>" +
        '<span class="mr-item__sel">' + ev.name + " &middot; " + ev.sizeLabel + "</span></span>" +
        '<button class="mr-edit" data-edit="' + i + '" type="button">' + (st.open ? "Done" : "Change") + "</button></div>" + poChip +
        '<div class="mr-item__panel"' + (st.open ? "" : " hidden") + ">" +
        '<div class="mr-preview"><span class="mr-preview__img" style="background-image:url(' + imgUrl(ev.image, 160) + ')"></span><div>' +
        '<div class="mr-preview__name">' + ev.name + "</div>" +
        '<div class="mr-preview__sub">' + ev.sizeLabel + " &middot; " + fmt(ev.priceCents) + (ev.preorder ? " &middot; pre-order, ships " + ev.preorderDate : "") + "</div>" +
        '<button class="mr-preview__link" data-view="' + i + '" type="button">Preview</button></div></div>' +
        (groups.length > 1 ? '<p class="mr-plabel">Range</p><div class="mr-ranges" role="group" aria-label="Range for ' + NOUN.s + " " + i + '">' +
          groups.map(function (grp, gi) { return '<button class="mr-range" type="button" data-item="' + i + '" data-gi="' + gi + '" aria-pressed="' + (st.gi === gi) + '">' + grp.title + "</button>"; }).join("") + "</div>" : "") +
        '<p class="mr-plabel mr-plabel--mt">Colour</p><div class="mr-thumbs" role="group" aria-label="Colour for ' + NOUN.s + " " + i + '">' +
        g.products.map(function (p, pi) { var cn = p.colour || p.title; return '<button class="mr-tbtn" type="button" title="' + cn + '" aria-label="' + cn + '" aria-pressed="' + (st.pi === pi) + '" data-item="' + i + '" data-pi="' + pi + '" style="background-image:url(' + imgUrl(p.image, 90) + ')"></button>'; }).join("") + "</div>" +
        '<p class="mr-plabel mr-plabel--mt">Size</p><select class="mr-size" data-item="' + i + '" aria-label="Size for ' + NOUN.s + " " + i + '">' +
        g.products[st.pi].sizes.map(function (s, si) { return "<option value=\"" + si + "\"" + (st.si === si ? " selected" : "") + (s.available ? "" : " disabled") + ">" + s.label + (s.available ? "" : " (sold out)") + "</option>"; }).join("") +
        "</select></div>";
      rowsEl.appendChild(row);
    }
    rowsEl.querySelectorAll(".mr-edit").forEach(function (b) { b.addEventListener("click", function () { var i = b.getAttribute("data-edit"); extras[i].open = !extras[i].open; render(); }); });
    rowsEl.querySelectorAll(".mr-range").forEach(function (b) { b.addEventListener("click", function () { var i = b.getAttribute("data-item"); extras[i].gi = +b.getAttribute("data-gi"); extras[i].pi = 0; extras[i].si = sizeIndexFor(extras[i].gi, 0, extras[i].sizeTouched && extraVariant(i) ? extraVariant(i).sizeLabel : (slot1 && slot1.label)); render(); }); });
    rowsEl.querySelectorAll(".mr-tbtn").forEach(function (b) { b.addEventListener("click", function () { var i = b.getAttribute("data-item"); var prev = extraVariant(i); extras[i].pi = +b.getAttribute("data-pi"); extras[i].si = sizeIndexFor(extras[i].gi, extras[i].pi, extras[i].sizeTouched && prev ? prev.sizeLabel : (slot1 && slot1.label)); render(); }); });
    rowsEl.querySelectorAll(".mr-size").forEach(function (sel) { sel.addEventListener("change", function () { var i = sel.getAttribute("data-item"); extras[i].si = +sel.value; extras[i].sizeTouched = true; render(); }); });
    rowsEl.querySelectorAll(".mr-preview__link").forEach(function (a) { a.addEventListener("click", function () { openPreview(+a.getAttribute("data-view")); }); });
  }
  function openPreview(i) {
    var ev = extraVariant(i); if (!ev) return;
    $("[data-qv-img]").style.backgroundImage = "url(" + imgUrl(ev.image, 600) + ")";
    $("[data-qv-name]").textContent = ev.name;
    $("[data-qv-sub]").textContent = ev.sizeLabel + " · " + fmt(ev.priceCents) + (ev.preorder ? " · pre-order, ships " + ev.preorderDate : "");
    var view = $("[data-qv-view]"); if (view) view.href = ROUTE_ROOT + "products/" + ev.product.handle + "?variant=" + numId(ev.variantId);
    $("[data-qv]").hidden = false;
  }
  function render() {
    if (!slot1) return;
    var s1po = preorderFor(slot1.variantId);
    $("[data-c1chip]").innerHTML = '<span class="mr-chip__line"><span class="mr-bed">' + BED + "</span>" + ROOMS[0] + " &middot; <strong>" + PRODUCT_TITLE + ", " + slot1.label + "</strong>, chosen above</span>" +
      (s1po ? '<span class="mr-chip__po"><span class="mr-po__tag">Pre-order</span><span class="mr-po__meta">ships ' + s1po.date + "</span></span>" : "");
    buildRows();
    [1, 2, 3].forEach(function (q) {
      var c = calc(q);
      var pn = $('[data-pn="' + q + '"]'); if (pn) pn.textContent = fmt(c.total);
      var sv = $('[data-sv="' + q + '"]'); if (sv) sv.textContent = "You save " + fmt(c.save);
    });
    $("[data-reward]").hidden = true;
    var list = slotList(qty); var anyPre = false, allPre = list.length > 0;
    list.forEach(function (s) { if (s.preorder) { anyPre = true; } else { allPre = false; } });
    var c = calc(qty); var when = "";
    if (anyPre) {
      var dates = {}; if (s1po) dates[s1po.date] = 1;
      for (var i = 2; i <= qty; i++) { var ev = extraVariant(i); if (ev && ev.preorder) dates[ev.preorderDate] = 1; }
      var dateList = Object.keys(dates).filter(Boolean);
      when = dateList.length === 1 ? " " + stripOrdinal(dateList[0]) : "";
    }
    var summary = $("[data-summary]");
    if (qty >= 2) {
      var unavailable = unavailableSlots(qty);
      if (unavailable.length) {
        // Never claim "Bundle ready" while the add path is dead — name the blocked slot(s).
        summary.innerHTML = unavailable.map(function (u) { return '<p class="mr-sum1" style="color:#b3261e">' + u + " unavailable — change size or colour</p>"; }).join("");
      } else {
        summary.innerHTML = '<p class="mr-sum1">✓ Bundle ready • ' + qty + " " + cap(NOUN.p) + " • Total " + fmt(c.total) + " AUD</p>" + (anyPre ? '<p class="mr-sum2">Pre-order item included • Ships together' + when + "</p>" : "");
      }
      summary.hidden = false;
    } else summary.hidden = true;
    $("[data-dispatch]").hidden = true;
    syncButton();
  }
  function select(q) {
    qty = q;
    root.querySelectorAll(".mr-tier").forEach(function (el) {
      var on = +el.getAttribute("data-qty") === q;
      el.classList.toggle("is-selected", on);
      el.querySelector("input").checked = on;
    });
    $("[data-config]").hidden = q < 2;
    render();
  }

  // ---- Add bundle ----------------------------------------------------------
  function lineProps(pre) { var p = { _bundle_builder: "true" }; if (pre) p.Pre = pre; return p; }
  function addBundle() {
    if (adding || !slot1) return;
    readSlot1(); syncExtraSizes(); if (!slot1) return;
    if (unavailableSlots(qty).length) { render(); return; } // summary shows which slot is blocked
    adding = true;
    var err = $("[data-error]"); err.hidden = true;
    var summary = $("[data-summary]"); summary.classList.add("is-adding");
    var items = [{ id: slot1.variantId, quantity: 1, properties: lineProps(slot1PreProperty()) }];
    for (var i = 2; i <= qty; i++) { var ev = extraVariant(i); if (ev) { var po = preorderFor(ev.variantId); items.push({ id: ev.variantId, quantity: 1, properties: lineProps(po ? po.note : null) }); } }
    var bundledSections = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:bundled-sections", { bubbles: true, detail: { sections: bundledSections } }));
    fetch(ROUTE_ROOT + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
      .then(function () {
        return fetch(ROUTE_ROOT + "cart/update.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ sections: bundledSections, sections_url: window.location.pathname }) }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var pubsub = window.theme && window.theme.pubsub;
        if (pubsub && pubsub.PUB_SUB_EVENTS && pubsub.PUB_SUB_EVENTS.cartUpdate && cart && cart.sections) {
          pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { source: "bundle-builder", cart: cart });
          var drawer = document.querySelector("cart-drawer");
          if (drawer && typeof drawer.show === "function") drawer.show();
        } else {
          document.dispatchEvent(new CustomEvent("cart:refresh", { detail: { open: true } }));
        }
      })
      .catch(function () { err.textContent = "Sorry, we couldn't add that bundle. Please try again, or contact " + CONTACT + "."; err.hidden = false; })
      .finally(function () { adding = false; summary.classList.remove("is-adding"); });
  }

  function resolveTargetForm() {
    var pi = root.closest("product-info"); var fid = pi && pi.getAttribute("form");
    if (fid) { var f = document.getElementById(fid); if (f) return f; }
    var forms = document.querySelectorAll('form[data-type="add-to-cart-form"]');
    for (var i = 0; i < forms.length; i++) { if (PRODUCT_ID && forms[i].id.indexOf(PRODUCT_ID) !== -1) return forms[i]; }
    return forms[0] || null;
  }
  function captureButton() {
    if (!targetForm) return;
    submitBtn = targetForm.querySelector(".product-form__submit") || targetForm.querySelector('button[name="add"]');
    if (!submitBtn) return;
    var priceEl = submitBtn.querySelector("product-buy-price");
    priceHasCode = priceEl ? /[A-Z]{3}/.test(priceEl.textContent || "") : true;
    btnObserver = new MutationObserver(function () { if (qty >= 2) applyBundleButton(); });
    btnObserver.observe(submitBtn, { subtree: true, childList: true, characterData: true });
    var stickyForm = document.querySelector(".product-sticky-form");
    if (stickyForm) {
      stickyBtn = stickyForm.querySelector('button[name="add"]');
      stickyPriceEl = stickyForm.querySelector('[id^="StickyPrice-"]');
      stickyTitleEl = stickyForm.querySelector('[data-sticky-product-title]');
      stickySubEl = stickyForm.querySelector('[data-sticky-product-options]');
      stickyBtnObserver = new MutationObserver(function () { if (qty >= 2) applyBundleButton(); });
      if (stickyBtn) stickyBtnObserver.observe(stickyBtn, { subtree: true, childList: true, characterData: true });
      if (stickyPriceEl) stickyBtnObserver.observe(stickyPriceEl, { subtree: true, childList: true, characterData: true });
      if (stickySubEl) stickyBtnObserver.observe(stickySubEl, { subtree: true, childList: true, characterData: true });
    }
  }

  // ---- Wiring --------------------------------------------------------------
  function wire() {
    var moreBtn = $("[data-more]");
    var expand = $("[data-expand]");
    moreBtn.addEventListener("click", function () {
      if (!catalogReady) return;
      var open = expand.hidden;
      expand.hidden = !open;
      moreBtn.setAttribute("aria-expanded", String(open));
      if (open) { expand.classList.remove("anim"); void expand.offsetWidth; expand.classList.add("anim"); if (qty < 2) select(2); else render(); }
    });
    $("[data-qv-close]").addEventListener("click", function () { $("[data-qv]").hidden = true; });
    $("[data-qv]").addEventListener("click", function (e) { if (e.target === $("[data-qv]")) $("[data-qv]").hidden = true; });

    // CAPTURE phase — catches non-bubbling variant:change from the theme form
    document.addEventListener("variant:change", function (e) {
      if (e.detail && e.detail.variant) {
        slot1 = slot1FromVariant(e.detail.variant);
        syncExtraSizes();
        render();
        onPickerUsed();
      }
    }, true);

    window.addEventListener("pageshow", function (e) { if (e.persisted) { readSlot1(); syncExtraSizes(); render(); } });

    document.addEventListener("submit", function (e) {
      if (!targetForm || e.target !== targetForm) return;
      if (qty >= 2 && catalogReady) { e.preventDefault(); e.stopImmediatePropagation(); addBundle(); }
    }, true);
  }

  function init() {
    if (!readSlot1()) return;
    loadCatalog().then(function () {
      if (!productQualifies) return; // v7 gate: this product is not in a qualifying collection -> never mount
      // v8 copy: name the range.
      var moreStrong = root.querySelector(".mr-more__txt strong"), moreSmall = root.querySelector(".mr-more__txt small");
      if (moreStrong) moreStrong.textContent = rangeName ? "Build your " + rangeName + " bundle & save" : "Build your bundle & save";
      if (moreSmall) moreSmall.textContent = (rangeName ? "Mix any " + rangeName + " colour or size. " : "Mix any colour or size. ") + "Save up to 15%.";
      targetForm = resolveTargetForm();
      captureButton();
      buildTiers();
      wire();
      root.hidden = false;
      select(1);
      var more = $("[data-more]");
      if (catalogReady) {
        [2, 3].forEach(function (i) { extras[i].gi = 0; extras[i].pi = 0; extras[i].si = sizeIndexFor(0, 0, slot1 && slot1.label); });
        more.hidden = false;
        // If picker was already used before catalog finished loading, expand now
        if (pickerUsed) doExpand();
      } else {
        more.hidden = true;
      }
      render();
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
